import lang from '@/lang'

export default {
  columns: [
    {
      field: 'humanizedDate',
      headerName: lang.generics.date,
      minWidth: 120,
    },
    {
      field: 'taskDescriptionPrefix',
      headerName: lang.timeTracking.taskLabel,
      cellRenderer: 'activityCellRenderer',
      minWidth: 200,
    },
    {
      field: 'trackedTimeString',
      headerName: lang.label.duration,
    },
    {
      field: 'summedUpConst',
      headerName: lang.customerStatisticsAmount,
    },
  ].map((column) => (
    {
      ...column,
      menuTabs: [],
      suppressMovable: true,
      suppressMenu: true,
      filter: false,
      resizable: false,
    }
  )),
}
